import currency from "../components/currency";

// Currency text
$(document).on('keyup', '.currency', function () {
    const value = $(this).val();
    $(this).val(currency.setCurrencyValue(value, 'Rp. '));
});

// Numeric text
$(document).on('keyup', '.numerical', function () {
	const value = $(this).val();
	$(this).val(currency.setCurrencyValue(value, ''));
});
